import React, { useState, useEffect, useRef, useMemo } from 'react';
import Popup from 'reactjs-popup';
import {
    IconFaFacebookSquare,
    IconFaInstagram,
    IconAiOutlineClose,
    IconFaGreaterThan,
    IconFaLessThan,
    DivItemCarrossel,
    DivCaption,
    TextareaSlider,
    DivTitle,
    DivBody,
    DivHeaderMain,
    DivMenu,
    DivBodyPage,
    IconIoMdArrowDropdown,
    IconIoMdArrowDropup,
    UlMenuTop,
    DivNextButton,
    DivPreviewSite,
    LiOpcoesMenuTop,
    LiNavigation,
    DivMainFirstPage,
    DivMainFooter,
    DivTextContent,
    DivMainSecondPage,
    DivMainAboutMe,
    IconGiHamburgerMenu,
    DivTextAreaTour,
    TextAreaTour,
    ImgLogoHeader,
    DivFooterContent,
    ImgPageContent,
    ImgCoverProfile,
    DivProfileContent,
    DivTextProfile,
} from './configPageBlogStyle';
import {
    DivMain,
    DivUlNavigation,
    UlNavigation,
    DivHeaderSocialMidia,
    ImgCarrossel,
    TitleFooter,
    PFooter,
    DivInputFile,
    LiChangeImageLogo,
    LiMenuTop,
} from './configPageBlogStyle';
import { IconMdBorderColor } from '../../components/menu/styles';
import { DivInput } from '../profile/profileStyled';
import { Input } from '../../styles/CommonStyles';
import { Button, SpanButton } from '../postEdit/stylePostEdit';
import InputFile from '../../components/inputs/inputFile/InputFile';
import LoadScreenSmall from '../../components/loadScreenSmall/loadScreenSmall';
import { SaveMyProfile } from '../../services/servicesPostSaveMyProfile';
import { GetCurrentUser } from '../../services/servicesGetCurrentUser';
import Toastify from '../../components/Toastify';
import CustomTour from '../../components/CustomTour/CustomTour';
import { Child, InputTitle, TextAreaSlider } from '../../components/CustomTour/CustomTour';
import {
    aboutmeTextMockup,
    styleParagraph,
    descriptionWelcomeMockup,
    descritptionPage1,
    descritptionPage2,
    menu1Mockup,
    menu2Mockup,
    styleInputInline,
    subMenuOptions,
    viewOP,
    imageCard1,
    imageCard2,
    imageCard3,
    logoMockup,
    coverMockup,
    profilePicturMockup,
} from '../../helpers/data';
import VerifyClickOut from '../../helpers/verifyClickOutElement';
import ImageEditor from '../../components/editorImage/editorImage';
function ConfigPageBlog() {
    const [verifyAnyPopupOpen, setVerifyAnyPopupOpen] = useState(false);
    const [popupLoadScreenSmall, setPopupLoadScreenSmall] = useState(false);
    const [active, setActive] = useState([true, false, false]);
    const [selected, setSelected] = useState('Página de Apresentação');
    const [openPopupInitialWarning, setOpenPopupInitialWarning] = useState(true);
    const [show, setShow] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);
    const refMenuNavigation = useRef();
    const refTextareaSlider0 = useRef();
    const refTextareaSlider1 = useRef();
    const refTextareaSlider2 = useRef();
    const refTextareaResumeText = useRef();
    const refLogo = useRef([]);
    const refMenu1 = useRef();
    const refMenu2 = useRef();
    const refCity1 = useRef();
    const refCity2 = useRef();
    const refAddress1 = useRef();
    const refAddress2 = useRef();
    const refPhone = useRef();
    const refWhatsapp = useRef({ refWhatsapp: null }).current;
    const refEmail = useRef();
    const refSliderCaption0 = useRef();
    const refInstagram = useRef();
    const refFacebook = useRef();
    const [dataSiteSliderPicture1, setDataSiteSliderPicture1] = useState({
        Image1: '',
    });
    const [dataSiteSliderPicture2, setDataSiteSliderPicture2] = useState({
        Image1: '',
    });
    const [dataSiteSliderPicture3, setDataSiteSliderPicture3] = useState({
        Image1: '',
    });
    const [dataSiteLogoHeader, setDataSiteLogoHeader] = useState({
        Image1: '',
    });
    const [dataSiteLogoHeaderMobile, setDataSiteLogoHeaderMobile] = useState({
        Image1: '',
    });
    const [dataSitePicture, setDataSitePicture] = useState({ Image1: '' });
    const [dataSiteCover, setDataSiteCover] = useState({ Image1: '' });
    const [dataSiteMenu1, setDataSiteMenu1] = useState('');
    const [dataSiteMenu2, setDataSiteMenu2] = useState('');

    const [dataSite, setDataSite] = useState({
        Address1: '',
        Address2: '',
        AliasFolder: '',
        AliasName: '',
        AnalyticsCode: '',
        City1: '',
        City2: '',
        Description: '',
        DescriptionPage1: '',
        DescriptionPage2: '',
        DescriptionWelcome: '',
        Email: '',
        Facebook: '',
        Instagram: '',
        Keywords: '',
        LogoMobile: '',
        Name: '',
        NewsLetterLink: '',
        OfficeEmail: '',
        OfficePhone1: '',
        OfficePhone2: '',
        ResumeText: '',
        SliderCaption1: '',
        SliderCaption2: '',
        SliderCaption3: '',
        SliderDescription1: '',
        SliderDescription2: '',
        SliderDescription3: '',
        Youtube: '',
    });

    //react tour
    const [allStatesOpenTour, setAllStatesOpenTour] = useState({
        openTourHeader: false,
        openTourFooter: false,
        openTourSlider: false,
        openTourTextPag1: false,
        openTourTextPag2: false,
        openTourAboutMePage: false,
    });

    const ButtonTour = (props) => {
        return (
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <p style={styleParagraph}>{props.text}</p>
                <br />
                <InputFile
                    mudaImg={props.setImage}
                    imagem={props.img}
                    load={popupLoadScreenSmall}
                    concluido={setPopupLoadScreenSmall}
                    name={props.buttonName}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '-45px',
                        height: '40px',
                        background: '#0594a5',
                        color: '#fff',
                        padding: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '6px',
                        border: '1px solid #047a89',
                        fontSize: '20px',
                    }}
                >
                    <span>{props.pageName ?? 'Início'}</span>
                </div>
            </div>
        );
    };
    const tours = [
        {
            name: 'stepHeader',
            steps: [
                {
                    selector: '#header',
                    content: <p style={styleParagraph}>Estas são as informações de cabeçalho do seu site.</p>,
                },
                {
                    selector: '#instagram',
                    content: Child({
                        instruction: 'Insira o seu perfil do instagram',
                        placeholder: 'Ex: @willianstsousa',
                        nameSocial: 'instagram',
                        refSocial: refInstagram,
                        dataSiteSocial: dataSite.Instagram,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                Instagram: event.currentTarget.value,
                            });
                        },
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#facebook',
                    content: Child({
                        instruction: 'Insira o seu perfil do facebook',
                        placeholder: 'Ex: @dev_auto_publish',
                        nameSocial: 'facebook',
                        refSocial: refFacebook,
                        dataSiteSocial: dataSite.Facebook,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                Facebook: event.currentTarget.value,
                            });
                        },
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#logoHeader',
                    content: ButtonTour({
                        text: 'Troque a sua logo, dimensões recomendadas 620 x 175',
                        setImage: setDataSiteLogoHeader,
                        img: dataSiteLogoHeader,
                        buttonName: 'Trocar Logo',
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#title1',
                    content: InputTitle({
                        refMenu: refMenu1,
                        title: 'Título da página 1',
                        dataSiteMenu: dataSiteMenu1,
                        setFunction: (event) => {
                            setDataSiteMenu1(event.currentTarget.value);
                        },
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#title2',
                    content: InputTitle({
                        refMenu: refMenu2,
                        title: 'Título da página 2',
                        dataSiteMenu: dataSiteMenu2,
                        setFunction: (event) => {
                            setDataSiteMenu2(event.currentTarget.value);
                        },
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            <p style={styleParagraph}>Configuração de cabeçalho concluída</p>
                            <br />
                            <Button
                                onClick={() => {
                                    setAllStatesOpenTour({
                                        ...allStatesOpenTour,
                                        openTourHeader: false,
                                        openTourSlider: true,
                                    });
                                }}
                            >
                                <SpanButton>Avançar</SpanButton>
                            </Button>
                        </div>
                    ),
                },
            ],
            openTour: allStatesOpenTour.openTourHeader,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourHeader: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
        {
            name: 'stepsFooter',
            steps: [
                {
                    selector: '#city1',
                    content: InputTitle({
                        title: 'cidade de atendimento',
                        refMenu: refCity1,
                        dataSiteMenu: dataSite.City1,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                City1: event.currentTarget.value,
                            });
                        },
                    }),
                },
                {
                    selector: '#address1',
                    content: InputTitle({
                        title: 'endereço de atendimento',
                        refMenu: refAddress1,
                        dataSiteMenu: dataSite.Address1,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                Address1: event.currentTarget.value,
                            });
                        },
                        maxLength: '50',
                    }),
                },
                {
                    selector: '#city2',
                    content: InputTitle({
                        title: 'cidade de atendimento2',
                        refMenu: refCity2,
                        dataSiteMenu: dataSite.City2,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                City2: event.currentTarget.value,
                            });
                        },
                    }),
                },
                {
                    selector: '#address2',
                    content: InputTitle({
                        title: 'endereço de atendimento ',
                        refMenu: refAddress2,
                        dataSiteMenu: dataSite.Address2,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                Address2: event.currentTarget.value,
                            });
                        },
                        maxLength: '50',
                    }),
                },
                {
                    selector: '#phone',
                    content: InputTitle({
                        title: 'telefone para contato',
                        refMenu: refAddress2,
                        dataSiteMenu: dataSite.OfficePhone2,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                OfficePhone2: event.currentTarget.value.replace(/\D+/g, ''),
                            });
                        },
                        maxLength: '11',
                    }),
                },
                {
                    selector: '#email',
                    content: InputTitle({
                        title: 'email para contato',
                        refMenu: refEmail,
                        dataSiteMenu: dataSite.Email,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                Email: event.currentTarget.value,
                            });
                        },
                        maxLength: '50',
                    }),
                },
                {
                    selector: '#whatsapp',
                    content: InputTitle({
                        title: 'email para contato',
                        refMenu: refWhatsapp,
                        dataSiteMenu: dataSite.OfficePhone1,
                        setFunction: (event) => {
                            setDataSite({
                                ...dataSite,
                                OfficePhone1: event.currentTarget.value.replace(/\D+/g, ''),
                            });
                        },
                        maxLength: '11',
                    }),
                },
                {
                    selector: '',
                    content: () => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                }}
                            >
                                <p style={styleParagraph}>As configurações desta página foram finalizadas.</p>
                                <br />
                                <Button
                                    onClick={() => {
                                        setAllStatesOpenTour({
                                            ...allStatesOpenTour,
                                            openTourFooter: false,
                                        });
                                        nextStep();
                                    }}
                                >
                                    <SpanButton>Avançar</SpanButton>
                                </Button>
                            </div>
                        );
                    },
                },
            ],
            openTour: allStatesOpenTour.openTourFooter,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourFooter: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
        {
            name: 'stepsSlider',
            steps: [
                {
                    selector: '#card1 img',
                    content: () => {
                        verifyOpCarrossel(1);
                        return ButtonTour({
                            text: 'Insira a imagem da página de apresentação, dimensões recomendadas 1080 x 620',
                            setImage: setDataSiteSliderPicture1,
                            img: dataSiteSliderPicture1,
                            buttonName: 'Trocar imagem',
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#card1 div h5',
                    content: () => {
                        verifyOpCarrossel(1);
                        return InputTitle({
                            title: 'título de apresentação do seu site',
                            refMenu: refSliderCaption0,
                            dataSiteMenu: dataSite.SliderCaption1,
                            setFunction: (event) =>
                                setDataSite({
                                    ...dataSite,
                                    SliderCaption1: event.currentTarget.value,
                                }),
                            maxLength: '150',
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#card1 div p',
                    content: () => {
                        verifyOpCarrossel(1);
                        return TextAreaSlider({
                            title: 'texto breve de apresentação do seu site',
                            refTextarea: refTextareaSlider0,
                            dataSliderTextarea: dataSite.SliderDescription1,
                            setFunction: (event) =>
                                setDataSite({
                                    ...dataSite,
                                    SliderDescription1: event.currentTarget.value,
                                }),
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#DescriptionWelcome',
                    content: () => {
                        const styleDivLocalizador = {
                            position: 'absolute',
                            top: '-45px',
                            height: '40px',
                            background: '#0594a5',
                            color: '#fff',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '6px',
                            border: '1px solid #047a89',
                            fontSize: '20px',
                        };
                        return (
                            <DivTextAreaTour>
                                <p style={styleParagraph}>
                                    Insira o texto de apresentação do seu site.
                                    <br /> {dataSite.DescriptionWelcome.length}
                                    /1000
                                </p>
                                <br />
                                <TextAreaTour
                                    maxLength="1000"
                                    value={dataSite.DescriptionWelcome}
                                    onBlur={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionWelcome: event.currentTarget.value,
                                        });
                                    }}
                                    onChange={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionWelcome: event.currentTarget.value,
                                        });
                                    }}
                                    placeholder={`Insira o texto de apresentação do seu site.`}
                                />
                                <div style={styleDivLocalizador}>
                                    <span>Início</span>
                                </div>
                            </DivTextAreaTour>
                        );
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <p style={styleParagraph}>Configuração do conteudo da página inicial finalizada</p>
                                <br />
                                <Button
                                    onClick={() => {
                                        setAllStatesOpenTour({
                                            ...allStatesOpenTour,
                                            openTourSlider: false,
                                            openTourFooter: true,
                                        });
                                    }}
                                >
                                    <SpanButton>avançar</SpanButton>
                                </Button>
                            </div>
                        );
                    },
                },
            ],
            openTour: allStatesOpenTour.openTourSlider,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourSlider: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
        {
            name: 'stepstextPag1',
            steps: [
                {
                    selector: '#imageCard2',
                    content: () => {
                        verifyOpCarrossel(2);
                        return ButtonTour({
                            text: `Insira a imagem da página ${
                                dataSiteMenu1 ? 'de ' + dataSiteMenu1 : '1'
                            }, dimensões recomendadas 1080 x 620`,
                            setImage: setDataSiteSliderPicture2,
                            img: dataSiteSliderPicture2,
                            buttonName: 'Trocar imagem',
                            pageName: dataSiteMenu1,
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        verifyOpCarrossel(2);
                        return TextAreaSlider({
                            title: 'breve texto para a página 1 do seu site',
                            refTextarea: refTextareaSlider0,
                            dataSliderTextarea: dataSite.SliderDescription2,
                            setFunction: (event) =>
                                setDataSite({
                                    ...dataSite,
                                    SliderDescription2: event.currentTarget.value,
                                }),
                            pageName: dataSiteMenu1,
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#textPag1',
                    content: () => {
                        return (
                            <DivTextAreaTour style={{ maxWidth: '100vw' }}>
                                <p style={styleParagraph}>
                                    Insira o texto do conteúdo do sua página referente à {dataSiteMenu1 || 'Página 1'}.
                                    <br /> {dataSite.DescriptionPage1.length}
                                    /1000
                                </p>
                                <br />
                                <TextAreaTour
                                    maxLength="1000"
                                    value={dataSite.DescriptionPage1}
                                    onBlur={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionPage1: event.currentTarget.value,
                                        });
                                    }}
                                    onChange={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionPage1: event.currentTarget.value,
                                        });
                                    }}
                                    placeholder={`Insira o texto de apresentação do seu site.`}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-45px',
                                        height: '40px',
                                        background: '#0594a5',
                                        color: '#fff',
                                        padding: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '6px',
                                        border: '1px solid #047a89',
                                        fontSize: '20px',
                                    }}
                                >
                                    <span>{dataSiteMenu1}</span>
                                </div>
                            </DivTextAreaTour>
                        );
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <p style={styleParagraph}> Configuração da primeira página concluída. </p>
                                <br />
                                <Button
                                    onClick={() => {
                                        setAllStatesOpenTour({
                                            ...allStatesOpenTour,
                                            openTourTextPag1: false,
                                        });
                                        nextStep();
                                    }}
                                >
                                    <SpanButton>Avançar</SpanButton>
                                </Button>
                            </div>
                        );
                    },
                },
            ],
            openTour: allStatesOpenTour.openTourTextPag1,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourTextPag1: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
        {
            name: 'stepstextPag2',
            steps: [
                {
                    selector: '#imageCard3',
                    content: () => {
                        verifyOpCarrossel(3);
                        return ButtonTour({
                            text: `Insira a imagem da página ${
                                dataSiteMenu2 ? 'de ' + dataSiteMenu2 : '2'
                            }, dimensões recomendadas 1080 x 620`,
                            setImage: setDataSiteSliderPicture3,
                            img: dataSiteSliderPicture3,
                            buttonName: 'Trocar imagem',
                            pageName: dataSiteMenu2,
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        verifyOpCarrossel(3);
                        return TextAreaSlider({
                            title: 'Breve texto para a página 2',
                            refTextarea: refTextareaSlider0,
                            dataSliderTextarea: dataSite.SliderDescription3,
                            setFunction: (event) =>
                                setDataSite({
                                    ...dataSite,
                                    SliderDescription3: event.currentTarget.value,
                                }),
                            pageName: dataSiteMenu2,
                        });
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#textPag2',
                    content: () => {
                        return (
                            <DivTextAreaTour>
                                <p style={styleParagraph}>
                                    Insira o texto do conteúdo do sua página referente à {dataSiteMenu2 || 'Página 2'}.
                                    <br /> {dataSite.DescriptionPage2.length}
                                    /1000
                                </p>
                                <br />
                                <TextAreaTour
                                    maxLength="1000"
                                    value={dataSite.DescriptionPage2}
                                    onBlur={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionPage2: event.currentTarget.value,
                                        });
                                    }}
                                    onChange={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            DescriptionPage2: event.currentTarget.value,
                                        });
                                    }}
                                    placeholder={`Insira o texto de apresentação do seu site.`}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-45px',
                                        height: '40px',
                                        background: '#0594a5',
                                        color: '#fff',
                                        padding: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '6px',
                                        border: '1px solid #047a89',
                                        fontSize: '20px',
                                    }}
                                >
                                    <span>{dataSiteMenu2}</span>
                                </div>
                            </DivTextAreaTour>
                        );
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <p style={styleParagraph}> Configuração da segunda página concluída. </p>
                                <br />
                                <Button
                                    onClick={() => {
                                        setAllStatesOpenTour({
                                            ...allStatesOpenTour,
                                            openTourTextPag2: false,
                                        });
                                        nextStep();
                                    }}
                                >
                                    <SpanButton>Avançar</SpanButton>
                                </Button>
                            </div>
                        );
                    },
                },
            ],
            openTour: allStatesOpenTour.openTourTextPag2,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourTextPag2: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
        {
            name: 'stepsPageAboutMe',
            steps: [
                {
                    selector: '#coverImg',
                    content: ButtonTour({
                        text: 'Insira a imagem de capa do perfil, dimensões recomendadas 1080 x 620',
                        setImage: setDataSiteCover,
                        img: dataSiteCover,
                        buttonName: 'Trocar Capa',
                        pageName: 'SOBRE MIM',
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#profilePicture',
                    content: ButtonTour({
                        text: 'Insira a imagem de página de apresentação, dimensões recomendadas 250 x 320',
                        setImage: setDataSitePicture,
                        img: dataSitePicture,
                        buttonName: 'Trocar foto de perfil',
                        pageName: 'SOBRE MIM',
                    }),
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '#textAboutMe',
                    content: () => {
                        return (
                            <DivTextAreaTour>
                                <p style={styleParagraph}>
                                    Insira um texto sobre você.
                                    <br /> {dataSite.ResumeText.length}/1000
                                </p>
                                <br />
                                <TextAreaTour
                                    maxLength="1000"
                                    value={dataSite.ResumeText}
                                    onBlur={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            ResumeText: event.currentTarget.value,
                                        });
                                    }}
                                    onChange={(event) => {
                                        setDataSite({
                                            ...dataSite,
                                            ResumeText: event.currentTarget.value,
                                        });
                                    }}
                                    placeholder={`Insira o texto de apresentação do seu site.`}
                                    style={{
                                        padding: '10px',
                                        fontSize: '18px',
                                        margin: '10px 0 0 10px',
                                    }}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-45px',
                                        height: '40px',
                                        background: '#0594a5',
                                        color: '#fff',
                                        padding: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '6px',
                                        border: '1px solid #047a89',
                                        fontSize: '20px',
                                    }}
                                >
                                    <span>SOBRE MIM</span>
                                </div>
                            </DivTextAreaTour>
                        );
                    },
                    style: { maxWidth: 'unset' },
                },
                {
                    selector: '',
                    content: () => {
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <p style={styleParagraph}> Configuração concluída </p>
                                <br />
                                <Button
                                    onClick={() => {
                                        setAllStatesOpenTour({
                                            ...allStatesOpenTour,
                                            openTourAboutMePage: false,
                                        });
                                        saveProfile();
                                    }}
                                >
                                    <SpanButton>Concluir</SpanButton>
                                </Button>
                            </div>
                        );
                    },
                },
            ],
            openTour: allStatesOpenTour.openTourAboutMePage,
            closeTour: () => {
                setAllStatesOpenTour({
                    ...allStatesOpenTour,
                    openTourAboutMePage: false,
                });
            },
            toggleVerifyAnyPopup: () => setVerifyAnyPopupOpen(false),
        },
    ];
    //  fim react tour

    function LogoHeader() {
        const logoHeader = useMemo(() => {
            return <ImgLogoHeader id="logoHeader" src={dataSiteLogoHeader.Image1 || logoMockup} />;
        }, [dataSiteLogoHeader]);
        return logoHeader;
    }
    function Seo(params) {
        return (
            <div>
                <DivInput>
                    <p>Palavras-chave para buscadores (Google)</p>
                    <Input
                        placeholder="Insira as palavras para otimzar a busca do Google"
                        defaultValue={''}
                        onChange={({ target }) => {
                            console.log(target);
                        }}
                    />
                </DivInput>
                <DivInput>
                    <p>Analitycs</p>
                    <Input
                        placeholder="Insira o codigo do Google Analitycs"
                        defaultValue={''}
                        onChange={({ target }) => {
                            console.log(target);
                        }}
                    />
                </DivInput>
                <DivInput>
                    <p>Descrição do blog</p>
                    <Input
                        placeholder="Insira uma descrição do blog para otimizar a busca do google"
                        defaultValue={''}
                        onChange={({ target }) => {
                            console.log(target);
                        }}
                    />
                </DivInput>
            </div>
        );
    }
    function Header() {
        return (
            <DivHeaderMain verifyAnyPopupOpen={verifyAnyPopupOpen} id="header" onClick={openTutorialHeader}>
                <DivHeaderSocialMidia id="redesSociais">
                    <div style={{ display: 'flex', alignItems: 'center' }} id="instagram">
                        <IconFaInstagram />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }} id="facebook">
                        <IconFaFacebookSquare />
                    </div>
                </DivHeaderSocialMidia>
                <div
                    ref={refLogo}
                    style={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    id="logo"
                >
                    <LogoHeader />
                    <DivInputFile></DivInputFile>
                </div>
                <DivMenu id="menu">
                    <ul>
                        <li>INÍCIO</li>
                        <li id="title1" ref={refMenu1}>
                            {dataSiteMenu1 || menu1Mockup}
                        </li>
                        <li id="title2" ref={refMenu2}>
                            {dataSiteMenu2 || menu2Mockup}
                        </li>
                        <li>BLOG</li>
                        <li>SOBRE MIM</li>
                    </ul>
                </DivMenu>
                <span> Clique aqui para editar as informações do campo de cabeçalho </span>
            </DivHeaderMain>
        );
    }
    function Footer() {
        return (
            <DivMainFooter verifyAnyPopupOpen={verifyAnyPopupOpen} onClick={openTutorialFooter}>
                <DivFooterContent>
                    <TitleFooter>INFORMAÇÕES SOBRE CONSULTAS</TitleFooter>
                    <PFooter>Locais de atendimento:</PFooter>
                    <PFooter>
                        <div>
                            <strong id="city1">{dataSite.City1 || 'Cidade1'} : </strong>{' '}
                            <span id="address1"> {dataSite.Address1 || 'Endereço1'}</span>
                        </div>
                    </PFooter>
                    <PFooter id="testepfooter">
                        <div>
                            <strong id="city2">{dataSite.City2 || 'Cidade1'} : </strong>{' '}
                            <span id="address2"> {dataSite.Address2 || 'Endereço2'}</span>
                        </div>
                    </PFooter>
                    <PFooter>
                        <div>
                            <strong>Telefone:</strong>
                            <span id="phone">{dataSite.OfficePhone2}</span>
                        </div>
                    </PFooter>
                    <PFooter>
                        <div>
                            <strong>Email:</strong>
                            <span id="email">{dataSite.Email}</span>
                        </div>
                    </PFooter>
                    <Button>
                        <SpanButton style={{ fontSize: '16px' }}>
                            WhatsApp <span id="whatsapp">{dataSite.OfficePhone1 || '21999999999'}</span>
                        </SpanButton>
                    </Button>
                </DivFooterContent>
                <DivFooterContent>
                    <TitleFooter>FIQUE POR DENTRO</TitleFooter>
                    <PFooter>Quer receber mais informações ?</PFooter>
                    <PFooter>Cadastre-se na minha newsletter</PFooter>
                    <PFooter>Pode ficar tranquilo(a) que não vou encher sua caixa de entrada.</PFooter>
                    <Button style={{ width: 'fit-content' }}>
                        <SpanButton style={{ fontSize: '16px' }}>
                            <nobr>Quero receber informações</nobr>
                        </SpanButton>
                    </Button>
                </DivFooterContent>
                <DivFooterContent>
                    <TitleFooter>SIGA-ME</TitleFooter>
                    <PFooter>Acompanhe-me nas minhas redes sociais:</PFooter>
                    <div style={{ cursor: 'pointer' }}>
                        <IconFaInstagram />
                        <IconFaFacebookSquare />
                    </div>
                </DivFooterContent>
                <span>Clique para editar as informações de rodapé</span>
            </DivMainFooter>
        );
    }
    function ImageCarrossel({ sliderPicture }) {
        const imageCarrossel = useMemo(() => {
            return <ImgCarrossel src={sliderPicture} alt="" />;
        }, [sliderPicture]);

        return imageCarrossel;
    }
    const ItemCarrossel = ({
        id,
        active,
        sliderPicture,
        sliderCaption,
        sliderDescription,
        prev1,
        prev2,
        prev3,
        next1,
        next2,
        next3,
        field,
        referenceMenu1,
        referenceMenu2,
        setImage,
        image,
        refInput,
        refTextArea,
    }) => {
        return (
            <DivItemCarrossel active={active} id={id}>
                <ImageCarrossel sliderPicture={sliderPicture} />
                <DivCaption>
                    <h5 ref={refInput}>{sliderCaption}</h5>
                    <br />
                    <p ref={refTextArea}>{sliderDescription}</p>
                </DivCaption>
                {/* <DivInputFile>
                <InputFile mudaImg={setImage} imagem={image} load={popupLoadScreenSmall} concluido={setPopupLoadScreenSmall} name="Alterar Imagem" />
            </DivInputFile> */}
                <IconFaLessThan id="prevStep" onClick={() => setActive([prev1, prev2, prev3])} />
                <IconFaGreaterThan id="nextStep" onClick={() => setActive([next1, next2, next3])} />
            </DivItemCarrossel>
        );
    };
    const CarrosselImagem = useMemo(() => {
        return (
            <div id="carrossel">
                <ItemCarrossel
                    id="card1"
                    active={active[0]}
                    sliderPicture={dataSiteSliderPicture1.Image1 || imageCard1}
                    sliderCaption={dataSite.SliderCaption1 || 'Emagrecimento e performance física com saúde.'}
                    sliderDescription={
                        dataSite.SliderDescription1 ||
                        'Meu objetivo é orientar e acompanhar meus pacientes para saúde, qualidade de vida e otimização metabólica.'
                    }
                    prev1={false}
                    prev2={false}
                    prev3={true}
                    next1={false}
                    next2={true}
                    next3={false}
                    field="SliderPicture1"
                    setImage={setDataSiteSliderPicture1}
                    image={dataSiteSliderPicture1}
                    refInput={refSliderCaption0}
                    refTextArea={refTextareaSlider0}
                />
                <ItemCarrossel
                    id="card2"
                    active={active[1]}
                    sliderPicture={dataSiteSliderPicture2.Image1 || imageCard2}
                    sliderCaption={dataSiteMenu1 || 'EMAGRECIMENTO'}
                    sliderDescription={
                        dataSite.SliderDescription2 || 'Informações sobre consultas para obesidade e emagrecimento.'
                    }
                    prev1={true}
                    prev2={false}
                    prev3={false}
                    next1={false}
                    next2={false}
                    next3={true}
                    field="SliderPicture2"
                    referenceMenu1={true}
                    setImage={setDataSiteSliderPicture2}
                    image={dataSiteSliderPicture2}
                    refTextArea={refTextareaSlider1}
                />
                <ItemCarrossel
                    id="card3"
                    active={active[2]}
                    sliderPicture={dataSiteSliderPicture3.Image1 || imageCard3}
                    sliderCaption={dataSiteMenu2 || 'PERFORMANCE'}
                    sliderDescription={
                        dataSite.SliderDescription3 ||
                        'Informações sobre consulta para otimização metabólica e performance física/esportiva.'
                    }
                    prev1={false}
                    prev2={true}
                    prev3={false}
                    next1={true}
                    next2={false}
                    next3={false}
                    field="SliderPicture3"
                    setImage={setDataSiteSliderPicture3}
                    image={dataSiteSliderPicture3}
                    referenceMenu2={true}
                    refTextArea={refTextareaSlider2}
                />
            </div>
        );
    }, [active, dataSiteSliderPicture1, dataSiteSliderPicture2, dataSiteSliderPicture3, dataSiteMenu1, dataSiteMenu2, dataSite]);
    function FirstPage() {
        return (
            <DivMainFirstPage
                verifyAnyPopupOpen={verifyAnyPopupOpen}
                id="textApresentação"
                onClick={openTutorialContentFirstPage}
            >
                <div style={{ width: '100%' }}> {CarrosselImagem} </div>
                <DivBodyPage id="DescriptionWelcome">
                    <div
                        style={{
                            resize: 'none',
                            fontSize: '20px',
                            padding: '10px',
                            margin: '20px auto 0 auto',
                            display: 'flex',
                            alignSelf: 'flex-start',
                            whiteSpace: 'break-spaces',
                            maxWidth: '1140px',
                            lineHeight: '30px',
                        }}
                    >
                        {dataSite.DescriptionWelcome || descriptionWelcomeMockup}
                    </div>
                </DivBodyPage>
                <span>Clique aqui para editar as configurações da página</span>
            </DivMainFirstPage>
        );
    }
    function SecondPage() {
        return (
            <DivMainSecondPage
                verifyAnyPopupOpen={verifyAnyPopupOpen}
                onClick={() => {
                    setAllStatesOpenTour({
                        ...allStatesOpenTour,
                        openTourTextPag1: true,
                    });
                    setVerifyAnyPopupOpen(true);
                }}
            >
                <ImgPageContent id="imageCard2" src={dataSiteSliderPicture2.Image1 || imageCard2} />
                <DivBodyPage id="text">
                    <h1>{dataSite.SliderCaption2 || menu1Mockup}</h1>
                    <DivTextContent id="textPag1">{dataSite.DescriptionPage1 || descritptionPage1}</DivTextContent>
                </DivBodyPage>
                <span>Clique para editar o texto do conteúdo dessa página</span>
            </DivMainSecondPage>
        );
    }
    function ThirdPage() {
        return (
            <DivMainSecondPage
                verifyAnyPopupOpen={verifyAnyPopupOpen}
                onClick={() =>
                    setAllStatesOpenTour({
                        ...allStatesOpenTour,
                        openTourTextPag2: true,
                    })
                }
            >
                <ImgPageContent id="imageCard3" src={dataSiteSliderPicture3.Image1 || imageCard3} />
                <DivBodyPage id="text2">
                    <h1>{dataSite.SliderCaption3 || menu2Mockup}</h1>
                    <DivTextContent id="textPag2">{dataSite.DescriptionPage2 || descritptionPage2}</DivTextContent>
                </DivBodyPage>
                <span>Clique para editar o texto do conteúdo dessa página</span>
            </DivMainSecondPage>
        );
    }
    function AboutMePage() {
        return (
            <DivMainAboutMe
                onClick={() =>
                    setAllStatesOpenTour({
                        ...allStatesOpenTour,
                        openTourAboutMePage: true,
                    })
                }
            >
                <ImgCoverProfile id="coverImg" src={dataSiteCover.Image1 || coverMockup} />
                <DivProfileContent>
                    <img id="profilePicture" src={dataSitePicture.Image1 || profilePicturMockup} />
                    <DivTextProfile>
                        <h1>Sobre Mim</h1>
                        <div id="textAboutMe" ref={refTextareaResumeText}>
                            {dataSite.ResumeText || aboutmeTextMockup}
                        </div>
                    </DivTextProfile>
                </DivProfileContent>
                <span>Clique para editar o conteúdo desta página</span>
            </DivMainAboutMe>
        );
    }
    async function loadProfile() {
        try {
            const data = await GetCurrentUser();
            // debugger
            setDataSite({
                ...dataSite,
                Address1: data.Address1,
                Address2: data.Address2,
                AliasFolder: data.AliasFolder,
                AliasName: data.AliasName,
                AnalyticsCode: data.AnalyticsCode,
                City1: data.City1,
                City2: data.City2,
                Description: data.Description,
                DescriptionPage1: data.DescriptionPage1,
                DescriptionPage2: data.DescriptionPage2,
                DescriptionWelcome: data.DescriptionWelcome,
                Email: data.Email,
                Facebook: data.Facebook,
                Instagram: `@${data.Instagram.split('/')[data.Instagram.split('/').length - 1]}`,
                Keywords: data.Keywords,
                LogoMobile: data.LogoMobile,
                Name: data.Name,
                NewsLetterLink: data.NewsLetterLink,
                OfficeEmail: data.OfficeEmail,
                OfficePhone1: data.OfficePhone1,
                OfficePhone2: data.OfficePhone2,
                ResumeText: data.ResumeText,
                SliderCaption1: data.SliderCaption1,
                SliderCaption2: data.SliderCaption2,
                SliderCaption3: data.SliderCaption3,
                SliderDescription1: data.SliderDescription1,
                SliderDescription2: data.SliderDescription2,
                SliderDescription3: data.SliderDescription3,
                Youtube: data.Youtube,
            });
            setDataSiteSliderPicture1({ Image1: data.SliderPicture1 });
            setDataSiteSliderPicture2({ Image1: data.SliderPicture2 });
            setDataSiteSliderPicture3({ Image1: data.SliderPicture3 });
            setDataSiteLogoHeader({ Image1: data.LogoHeader });
            setDataSiteLogoHeaderMobile({ Image1: data.LogoMobile });
            setDataSitePicture({ Image1: data.Picture });
            setDataSiteCover({ Image1: data.Cover });
            setDataSiteMenu1(data.SliderCaption2);
            setDataSiteMenu2(data.SliderCaption3);
        } catch (error) {
            Toastify.error('Não foi possível carregar dados de perfil.');
        }
    }
    async function saveProfile() {
        setPopupLoadScreenSmall(true);
        const data = await SaveMyProfile({
            Nome: dataSite.Name,
            Email: dataSite.Email,
            Cover: dataSiteCover.Image1,
            Image1: dataSitePicture.Image1,
            EmailConsultorio: dataSite.OfficeEmail,
            Telefone: dataSite.OfficePhone1,
            Telefone2: dataSite.OfficePhone2,
            Curriculo: dataSite.ResumeText,
            NomeBlog: dataSite.AliasName,
            EnderecoBlog: dataSite.AliasFolder,
            Instagram: `https://instagram.com/${dataSite.Instagram.replace('@', '')}`,
            FanpageFacebook: dataSite.Facebook,
            Youtube: '',
            PalavraGoogle: dataSite.Keywords,
            Description: dataSite.Description,
            DescriptionWelcome: dataSite.DescriptionWelcome,
            DescriptionPage1: dataSite.DescriptionPage1,
            DescriptionPage2: dataSite.DescriptionPage2,
            SliderCaption1: dataSite.SliderCaption1,
            SliderCaption2: dataSiteMenu1,
            SliderCaption3: dataSiteMenu2,
            SliderDescription1: dataSite.SliderDescription1,
            SliderDescription2: dataSite.SliderDescription2,
            SliderDescription3: dataSite.SliderDescription3,
            SliderPicture1: dataSiteSliderPicture1.Image1,
            SliderPicture2: dataSiteSliderPicture2.Image1,
            SliderPicture3: dataSiteSliderPicture3.Image1,
            LogoHeader: dataSiteLogoHeader.Image1,
            LogoMobile: dataSiteLogoHeaderMobile.Image1,
            City1: dataSite.City1,
            City2: dataSite.City2,
            Address1: dataSite.Address1,
            Address2: dataSite.Address2,
            AnalyticsCode: dataSite.AnalyticsCode,
            NewsLetterLink: dataSite.NewsLetterLink,
        });
        if (data.status === 200) Toastify.success('Dados salvos com sucesso');
        else Toastify.error('Erro ao salvar os dados');
        setPopupLoadScreenSmall(false);
    }
    async function nextStep() {
        if (selected === viewOP.cabecalho_e_rodape) {
            // await saveProfile();
            setSelected(viewOP.pagina_de_apresentacao);
        } else if (selected === viewOP.pagina_de_apresentacao) {
            // await saveProfile();
            setSelected(viewOP.pagina_artigo_1);
        } else if (selected === viewOP.pagina_artigo_1) {
            // await saveProfile();
            setSelected(viewOP.pagina_artigo_2);
        } else if (selected === viewOP.pagina_artigo_2) {
            // await saveProfile();
            setSelected(viewOP.pagina_de_perfil);
        } else {
            return;
        }
    }
    function prevStep() {
        if (selected === viewOP[4]) {
            setSelected(viewOP[3]);
        } else if (selected === viewOP[3]) {
            setSelected(viewOP[2]);
        } else if (selected === viewOP[2]) {
            setSelected(viewOP[1]);
        } else if (selected === viewOP[1]) {
            setSelected(viewOP[0]);
        } else {
            return;
        }
    }
    function verifyOpCarrossel(option) {
        //acessar primeira tela
        if (option === 1) {
            if (active[0] === true && active[1] === false && active[2] === false) {
                return;
            } else if (active[0] === false && active[1] === true && active[2] === false) {
                setActive([true, false, false]);
            } else if (active[0] === false && active[1] === false && active[2] === true) {
                setActive([true, false, false]);
            }
        } else if (option === 2) {
            if (active[0] === false && active[1] === true && active[2] === false) {
                return;
            } else if (active[0] === true && active[1] === false && active[2] === false) {
                setActive([false, true, false]);
            } else if (active[0] === false && active[1] === false && active[2] === true) {
                setActive([false, true, false]);
            }
        } else if (option === 3) {
            if (active[0] === false && active[1] === false && active[2] === true) {
                return;
            } else if (active[0] === true && active[1] === false && active[2] === false) {
                setActive([false, true, false]);
            } else if (active[0] === false && active[1] === true && active[2] === false) {
                setActive([false, false, true]);
            }
        }

        //acessar segunda tela
        //acessar terceira tela
    }
    function verifyStep(step_name) {
        const options = localStorage.getItem('steps_helper');
        const obj = JSON.parse(options);
        return parseInt(obj[step_name]);
    }
    function openTutorialHeader() {
        setVerifyAnyPopupOpen(true);
        setAllStatesOpenTour({ ...allStatesOpenTour, openTourHeader: true });
    }
    function openTutorialContentFirstPage() {
        setVerifyAnyPopupOpen(true);
        setAllStatesOpenTour({ ...allStatesOpenTour, openTourSlider: true });
    }
    function openTutorialFooter() {
        setVerifyAnyPopupOpen(true);
        setAllStatesOpenTour({ ...allStatesOpenTour, openTourFooter: true });
    }
    function showMenu() {
        setShow(!show);
    }

    useEffect(() => {
        if (!localStorage.getItem('steps_helper')) {
            const objHelper = {
                steps: 0,
                stepsFooter: 0,
                stepsSlider: 0,
                steps2: 0,
                stepstextPag1: 0,
                stepstextPag2: 0,
                stepsPageAboutMe: 0,
            };
            localStorage.setItem('steps_helper', JSON.stringify(objHelper));
        }
        // if(selected === "Página de Apresentação"){

        // }
        loadProfile();
    }, []);

    useEffect(() => {
        if (selected == viewOP.pagina_artigo_1) {
            setVerifyAnyPopupOpen(true);
            setAllStatesOpenTour({
                ...allStatesOpenTour,
                openTourTextPag1: true,
            });
        } else if (selected === viewOP.pagina_artigo_2) {
            setVerifyAnyPopupOpen(true);
            setAllStatesOpenTour({
                ...allStatesOpenTour,
                openTourTextPag2: true,
            });
        } else if (selected === viewOP.pagina_de_perfil) {
            setVerifyAnyPopupOpen(true);
            setAllStatesOpenTour({
                ...allStatesOpenTour,
                openTourAboutMePage: true,
            });
        }
    }, [selected]);

    return (
        <DivMain>
            <DivTitle>
                {/* menu when width < 800px*/}
                <IconGiHamburgerMenu onClick={showMenu} />
                {/* menu when width < 800px*/}
                <UlMenuTop showDisplay={show} onBlurCapture={showMenu}>
                    <LiOpcoesMenuTop completed={true} onClick={prevStep}>
                        <span>Anterior</span>
                    </LiOpcoesMenuTop>
                    <LiMenuTop
                        selected={selected == 'Página de Apresentação'}
                        onClick={() => setSelected('Página de Apresentação')}
                    >
                        INÍCIO
                    </LiMenuTop>
                    <span>{`>`}</span>
                    <LiMenuTop selected={selected == 'Página Artigo 1'} onClick={() => setSelected('Página Artigo 1')}>
                        {dataSiteMenu1 === '' ? 'PÁGINA 1' : dataSiteMenu1}
                    </LiMenuTop>
                    <span>{`>`}</span>
                    <LiMenuTop selected={selected == 'Página Artigo 2'} onClick={() => setSelected('Página Artigo 2')}>
                        {dataSiteMenu2 === '' ? 'PÁGINA 2' : dataSiteMenu2}
                    </LiMenuTop>
                    <span>{`>`}</span>
                    <LiMenuTop selected={selected == 'Página de perfil'} onClick={() => setSelected('Página de perfil')}>
                        SOBRE MIM
                    </LiMenuTop>
                    <LiOpcoesMenuTop completed={selected !== viewOP.pagina_de_perfil} onClick={nextStep}>
                        Seguinte
                    </LiOpcoesMenuTop>
                    <LiOpcoesMenuTop completed={selected === viewOP.pagina_de_perfil} onClick={saveProfile}>
                        Concluir
                    </LiOpcoesMenuTop>
                </UlMenuTop>
            </DivTitle>
            <DivBody>
                <DivPreviewSite id="pageSelected">
                    {selected == 'SEO' ? (
                        <div>
                            <Seo />
                        </div>
                    ) : (
                        <>
                            <Header />
                            {selected == 'Página de Apresentação' ? (
                                <FirstPage />
                            ) : selected == 'Página Artigo 1' ? (
                                <SecondPage />
                            ) : selected == 'Página Artigo 2' ? (
                                <ThirdPage />
                            ) : selected == 'Página de perfil' ? (
                                <AboutMePage />
                            ) : (
                                ''
                            )}
                            <Footer />
                        </>
                    )}
                </DivPreviewSite>
            </DivBody>
            <Popup
                open={openPopupInitialWarning}
                onClose={() => setOpenPopupInitialWarning(false)}
                contentStyle={{
                    width: 'fit-content',
                    height: 'fit-content',
                    borderRadius: '6px',
                }}
            >
                <div style={{ padding: '16px' }}>
                    <p style={{ fontSize: '20px' }}>Irei guiar a sua configuração para a criação do seu site.</p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            margin: '16px 0 0 0',
                        }}
                    >
                        <Button
                            onClick={() => {
                                setOpenPopupInitialWarning(false);
                                setAllStatesOpenTour({
                                    ...allStatesOpenTour,
                                    openTourHeader: true,
                                });
                                setVerifyAnyPopupOpen(true);
                            }}
                        >
                            <SpanButton>Iniciar</SpanButton>
                        </Button>
                        <Button onClick={() => setOpenPopupInitialWarning(false)}>
                            <SpanButton>Pular</SpanButton>
                        </Button>
                    </div>
                </div>
            </Popup>
            <LoadScreenSmall open={popupLoadScreenSmall} close={setPopupLoadScreenSmall} />
            {tours.map((item) => {
                try {
                    return (
                        <CustomTour
                            steps={item.steps}
                            openTour={item.openTour}
                            closeTour={item.closeTour}
                            toggleVerifyAnyPopup={item.toggleVerifyAnyPopup}
                        />
                    );
                } catch (error) {
                    console.log(error);
                }
            })}
            <Popup open={openEditor} onClose={() => setOpenEditor(false)}>
                <ImageEditor
                    close={setOpenEditor}
                    image={dataSiteLogoHeader.Image1}
                    text={''}
                    exibe={setDataSiteLogoHeader}
                    save={''}
                    loadScreen={setPopupLoadScreenSmall}
                />
            </Popup>
        </DivMain>
    );
}
export default ConfigPageBlog;
